export default __webpack_public_path__ + "static/media/doc.e800057e.svg";